"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PulseTableHelpers_1 = require("./helpers/PulseTableHelpers");
// eslint-disable-next-line @typescript-eslint/ban-types
function PulseTable(props) {
    function renderRow(item) {
        return (react_1.default.createElement("tr", { className: "pulse-table-row" }, (0, PulseTableHelpers_1.objectKeys)(item).map(function (itemProperty, index) {
            var _a;
            var customRenderer = (_a = props.customRenderers) === null || _a === void 0 ? void 0 : _a[itemProperty];
            if (customRenderer) {
                return (react_1.default.createElement("td", { align: "left", className: "pulse-table-row-item" }, customRenderer(item)));
            }
            return (react_1.default.createElement("td", { align: "left", className: "pulse-table-row-item", key: index }, (0, PulseTableHelpers_1.isPrimitive)(item[itemProperty]) ? item[itemProperty] : ""));
        })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, props.items.length > 0 ? (react_1.default.createElement("div", { className: "pulse-table-wrapper" },
        react_1.default.createElement("table", { className: "pulse-table fadeIn" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", { className: "pulse-table-header" }, (0, PulseTableHelpers_1.objectValues)(props.headers).map(function (headerValue, index) { return (react_1.default.createElement("th", { align: "left", className: "pulse-table-header-item", key: index }, headerValue)); }))),
            react_1.default.createElement("tbody", null, props.items.map(renderRow))))) : (react_1.default.createElement(react_1.default.Fragment, null, props.noItemsSection))));
}
exports.default = PulseTable;
